import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  padding: 1rem;
  background-color: ${(props) => props.theme.lightGreyColor};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Text = styled.p`
  font-size: 1.2rem;
  font-weight: 400;
`;

const ComingSoonPlaceholder = () => (
  <Container>
    <Text>COMING SOON!</Text>
  </Container>
);

export default ComingSoonPlaceholder;
